//@ts-strict-ignore
import React, { useContext } from 'react';
import { default as Form } from '../../components/connectedForm';
import * as input from '../../components/connectedForm/inputComponents';
import Formatters from '../../components/grid-addons/formatters';
import ConnectedFormContext from '../../components/Context/ConnectedFormContext';
import { ISupplier } from '../../graphql/schema/p4types';
import { useDispatch } from 'react-redux';
import getIn from '../../components/connectedForm/utils/getIn';

const SupplierCarriageCosts = () => {
  const connectedForm = useContext(ConnectedFormContext);
  const values: ISupplier = connectedForm.values as ISupplier;

  const carriageMatrix = [
    {
      name: 'Weight/Val',
      key: 'key',
      editable: true,
      resizable: true,
      formatter: Formatters.NumericFormatter,
      options: {
        format: { decimals: 2 },
      },
    },
    {
      name: 'Cost',
      key: 'value',
      editable: true,
      resizable: true,
      formatter: Formatters.NumericFormatter,
      options: {
        format: { decimals: 2 },
      },
    },
  ];

  const dispatch = useDispatch();

  const deleteCarriageCost = (rowIdx) => {
    const dataid = `carriageCosts.costMatrix.${rowIdx}.deleted`;
    dispatch(connectedForm.change(dataid, !values.carriageCosts?.costMatrix?.[rowIdx]?.deleted));
  };

  return (
    <>
      <Form.Row>
        <Form.Fieldset cols={1}>
          <Form.Legend label="Carriage Costs" />
          <Form.Field dataid="carriageCosts.calculationMethod" component={input.Dropdown} label="Calculation Method" />
          <Form.Field dataid="carriageCosts.chargeBasis" component={input.Dropdown} label="Cost Basis" />
          <Form.Field
            dataid="carriageCosts.excludeVatFromCalculation"
            component={input.Checkbox}
            label="Exclude VAT from calculation"
          />
        </Form.Fieldset>
      </Form.Row>
      {values.carriageCosts?.calculationMethod === 'CALCULATED' ? (
        <Form.Row>
          <Form.Fieldset cols={1}>
            <Form.Legend label="Costs Matrix" />
            <Form.Field
              dataid="carriageCosts.costMatrix"
              component={input.DataGrid}
              label=""
              columns={carriageMatrix}
              enableCellSelect={true}
              enableCellAutoFocus={false}
              addBlankRow={true}
              deleteOption={deleteCarriageCost}
            />
          </Form.Fieldset>
        </Form.Row>
      ) : null}
    </>
  );
};

export default SupplierCarriageCosts;
